<template>
  <div class="c-empty-state">
    <div
      class="c-empty-state__icon"
      :class="{ 'c-empty-state__icon--light': iconStyle === 'light' }"
    >
      <slot name="icon" />
      <o-icon :icon="icon" size="large" v-if="!$slots.icon" />
    </div>
    <p class="c-empty-state__label">{{ label }}</p>
  </div>
</template>

<script>
export default {
  name: 'OEmptyState',
  props: {
    icon: {
      type: String,
      default: 'check'
    },
    iconStyle: String,
    label: String
  }
}
</script>

<style lang="scss">
.c-empty-state {
  align-items: center;
  justify-content: center;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  padding: 1.6rem;
}

.c-empty-state__icon {
  background: #fff;
  border-radius: 50%;
  color: $primary-color;
  color: var(--primary-color);
  display: flex;
  height: 6.4rem;
  margin-bottom: 1.6rem;
  width: 6.4rem;

  & > * {
    display: block;
    margin: auto;
  }
}

.c-empty-state__icon--light {
  background: rgba($primary-color, 0.1);
  background: var(--primary-color-light);
}

.c-empty-state__label {
  font-size: 1.6rem;
  line-height: 2.4rem;
  text-align: center;
}
</style>
